import { render, staticRenderFns } from "./modalUsuarioPortal.vue?vue&type=template&id=2abd68d8&"
import script from "./modalUsuarioPortal.vue?vue&type=script&lang=js&"
export * from "./modalUsuarioPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports